import { render, staticRenderFns } from "./sale-order.vue?vue&type=template&id=208f15dd&scoped=true"
import script from "./sale-order.vue?vue&type=script&lang=js"
export * from "./sale-order.vue?vue&type=script&lang=js"
import style0 from "./sale-order.vue?vue&type=style&index=0&id=208f15dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f15dd",
  null
  
)

export default component.exports